/* eslint-disable no-shadow */
export var AllowanceFrequency;
(function (AllowanceFrequency) {
    AllowanceFrequency["NO_RECURRENCE"] = "NO_RECURRENCE";
    AllowanceFrequency["DAILY"] = "DAILY";
    AllowanceFrequency["WEEKLY"] = "WEEKLY";
    AllowanceFrequency["MONTHLY"] = "MONTHLY";
})(AllowanceFrequency || (AllowanceFrequency = {}));
export var allowanceStatus;
(function (allowanceStatus) {
    allowanceStatus["ACTIVE"] = "ACTIVE";
    allowanceStatus["LOCKED"] = "LOCKED";
    allowanceStatus["USED"] = "USED";
    allowanceStatus["REVOKED"] = "REVOKED";
    allowanceStatus["EXPIRED"] = "EXPIRED";
    allowanceStatus["DELETED"] = "DELETED";
})(allowanceStatus || (allowanceStatus = {}));
export var CardStatus;
(function (CardStatus) {
    CardStatus["ACTIVE"] = "Active";
    CardStatus["INACTIVE"] = "Inactive";
})(CardStatus || (CardStatus = {}));
export var assignedRole;
(function (assignedRole) {
    assignedRole["PURCHASER"] = "PURCHASER";
    assignedRole["RUNNER"] = "RUNNER";
    assignedRole["ADMIN"] = "ADMIN";
})(assignedRole || (assignedRole = {}));
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["DISABLE"] = "Disable";
    ACTIONS["DELETE"] = "Delete";
})(ACTIONS || (ACTIONS = {}));
